import React from "react";
import { FIELD_BASE } from "./fieldClasses";

export function Input({ value, onChange, placeholder = "", type = "text", className = "", style, ...props }) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`${FIELD_BASE.replace('border-white/30', '')} min-h-[48px] text-base rounded-xl border ${className}`}
      style={{ 
        fontSize: 'max(16px, 1rem)',
        borderColor: 'rgba(96, 165, 250, 0.3)',
        borderWidth: '1px',
        color: '#4B5563',
        ...style
      }}
      {...props}
    />
  );
}
